import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsToRescueProject(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Přetížený web či e-shop",
			desc: "„Spustili jsme na e-shopu kampaň, ale web nezvládl nával zákazníků a přestal fungovat. Potřebujeme, aby byl e-shop stabilní i při vysoké návštěvnosti.“",
		},
		{
			title: "Nedostatek interních kapacit",
			desc: "„Náš ajťák má práce nad hlavu a nerozumí novým technologiím. Zjistili jsme, že si neporadí s tvorbou nového firemního webu, nezvládne to ani nikdo jiný ve firmě.“",
		},
		{
			title: "Dodavatel nedodržuje termíny",
			desc: "„Náš původní dodavatel už dlouho slibuje dokončení projektu, ale nikam se to neposunuje. Podle uvedených technologiích si s projektem dokážete poradit i vy. Pomůžete nám ho dokončit?“",
		},
		{
			title: "Ajťák odešel a nemáme náhradu",
			desc: "„Dlouho pro nás pracoval šikovný ajťák, ale nedávno nečekaně odešel a nemáme za něj náhradu. Zůstala po něm spousta rozdělané práce.“",
		},
		{
			title: "Drahé servery s nízkým výkonem",
			desc: "„Provoz serverů nás stojí spoustu peněz a zároveň nejsou dostatečně výkonné, už neutáhnou naše aplikace. Pomůžete nám s tím?“",
		},
		{
			title: "Nečekané zdražení u dodavatele",
			desc: "„Původní dodavatel začal chtít velké peníze i za drobnosti, přestalo se nám to líbit.“",
		},
	];
}
